<template>
  <div class="overflow-x-auto bg-[#f8f8f8] rounded-[8px]">
    <div class="p-[8px] grid grid-cols-4 gap-[8px] min-w-[1000px]">
      <product-card :products="data.products" />
      <div>
        <item-card label="Penerima">
          {{ data.recipient }}.<br> {{ data.recipient_address }}
        </item-card>
      </div>
      <div>
        <item-card label="Bahan Packing">
          <span v-if="!data.packing_materials">
            -
          </span>
          <ul
            v-else
            class="list-disc ml-[12px]"
          >
            <li
              v-for="packing in data.packing_materials"
              :key="packing.id"
            >
              <div class="flex items-center justify-between gap-[4px]">
                <span>{{ packing.name }}</span>
                <span>
                  x {{ packing.layer }}
                </span>
              </div>
            </li>
          </ul>
        </item-card>
      </div>
    </div>

  </div>
</template>

<script>
import ProductCard from './ProductCard.vue'
import ItemCard from './ItemCard.vue'

export default {
  components: {
    ProductCard,
    ItemCard,
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        products: [],
        recipient: '-',
        recipient_address: '-',
        logistic_name: '-',
      }),
    },
  },
  computed: {
    fulfillmentFee() {
      return this.data.fulfillment_fee ? this.data.fulfillment_fee : 0
    },
  },
  methods: {
    showModalTrackingPacket() {
      this.$refs.modalTrackingPacket.showModal({
        marketplace: this.data.marketplace,
        awb: this.data.awb,
        logisticName: this.data.logistic_name,
        orderId: this.data.id,
      })
    },
  },
}
</script>
